<template>
  <el-dialog  v-model="outerVisible" v-if="outerVisible" :width="size.width" :height="size.height" @opened="handleOpened"
    @close="handleClosed">
    <div id="showid" ref="modelContainer">
      <!-- <div v-for="(annotation, index) in annotations" :key="index" class="annotation"
        :style="{ left: annotation.position.x + 'px', top: annotation.position.y + 'px'}"
        @mouseenter="showAnnotation(annotation)" @mouseleave="hideAnnotation(annotation)">
        {{ annotation.name }},{{index}}
      </div> -->
      <!-- 位置1 -->
      <div class="annotation dotsinfo1" 
      :style="{ 
        left: devInfors.dotsinfo1.position.x + devInfors.dotsinfo1.leftX + 'px',
        top: devInfors.dotsinfo1.position.y + devInfors.dotsinfo1.topY + 'px',
        display: devInfors.dotsinfo1.position.x && (devInfors.dotsinfo1.sensorval).length !=0 ? 'block' : 'none'
        }"
      >
        <div class="annattion_content"
           v-for=" val in devInfors.dotsinfo1.sensorval"
          :key="val.id"
          :style="{
            display:   val.type==1 ? 'block' : 'none'}"
         >
        <span style="font-weight: 700; color: #fff">名称：{{val.name}}:</span>
        <span>振动值：{{val.intensity}}mm/s</span>
        <span>温度：{{val.temperature}}°C</span>
        <span>电池电量：{{(val.battery*100).toFixed(1)}}%</span>
        <span>电流：{{devInfors.current}}A </span>
        </div>
      </div>
         <!-- 位置2 -->
         <div class="annotation dotsinfo2" 
        :style="{ 
          left: devInfors.dotsinfo2.position.x + devInfors.dotsinfo2.leftX + 'px',
          top: devInfors.dotsinfo2.position.y + devInfors.dotsinfo2.topY + 'px',
          display: devInfors.dotsinfo4.position.x && (devInfors.dotsinfo4.sensorval).length !=0 ? 'block' : 'none'
          }"
      >
        <div class="annattion_content"
           v-for=" val in devInfors.dotsinfo2.sensorval"
          :key="val.id"
          :style="{ display:  val.type==1 ? 'block' : 'none'}"
         >
        <span style="font-weight: 700; color: #fff">名称：{{val.name }}:</span>
        <span>振动值：{{val.intensity}}mm/s</span>
        <span>温度：{{val.temperature}}°C</span>
        <span>电池电量：{{(val.battery*100).toFixed(1)}}%</span>
        <span>电流：{{devInfors.current}}A</span>
        </div>
      
         </div>
       <!-- 位置3 -->
       <div class="annotation dotsinfo3" 
        :style="{ 
          left: devInfors.dotsinfo3.position.x + devInfors.dotsinfo3.leftX + 'px',
          top: devInfors.dotsinfo3.position.y + devInfors.dotsinfo3.topY + 'px',
          display: devInfors.dotsinfo4.position.x && (devInfors.dotsinfo4.sensorval).length !=0 ? 'block' : 'none'
          }"
      >
        <div class="annattion_content"
           v-for=" val in devInfors.dotsinfo3.sensorval"
          :key="val.id"
          :style="{ display:   val.type==1 ? 'block' : 'none'}"
         >
        <span style="font-weight: 700; color: #fff">名称：{{val.name }}:</span>
        <span>振动值：{{val.intensity}}mm/s</span>
        <span>温度：{{val.temperature}}°C</span>
        <span>电池电量：{{(val.battery*100).toFixed(1)}}%</span>
        <span>电流：{{devInfors.current}}A</span>
        

        </div>
      
        </div>
         <!-- 位置4 -->
         <div class="annotation dotsinfo4" 
        :style="{ 
          left: devInfors.dotsinfo4.position.x + devInfors.dotsinfo4.leftX + 'px',
          top: devInfors.dotsinfo4.position.y + devInfors.dotsinfo4.topY + 'px',
          display: devInfors.dotsinfo4.position.x && (devInfors.dotsinfo4.sensorval).length !=0 ? 'block' : 'none' 
          }">
       
        <div class="annattion_content"
           v-for=" val in devInfors.dotsinfo4.sensorval"
          :key="val.id"
          :style="{   display:  val.type==1 ? 'block' : 'none'}"
         >
        <span style="font-weight: 700; color: #fff">名称：{{val.name }}:</span>
        <span>振动值：{{val.intensity}}mm/s</span>
        <span>温度：{{val.temperature}}°C</span>
        <span>电池电量：{{(val.battery*100).toFixed(1)}}%</span>
        <span>电流：{{devInfors.current}}A</span>
        </div>
        </div>
      <!-- <div v-for="(dot, index) in dots" :key="'dot-' + index" class="dot"
        :style="{ left: dot.position.x + 'px', top: dot.position.y + 'px' ,}" 
        @mouseenter="showAnnotation(dot.annotation)" @mouseleave="hideAnnotation(dot.annotation)">
     
      </div>  -->
   
    </div>
  </el-dialog>
</template>

<script setup name="model3d">
import { ref } from 'vue';
import * as THREE from 'three';
import { GLTFLoader } from 'three/examples/jsm/loaders/GLTFLoader.js';
import { OrbitControls } from 'three/examples/jsm/controls/OrbitControls.js';
import  { model3dinfors } from '@/config/model3dinfors'
import mitter from '@/utils/mitt';

const modelContainer = ref(null);
const annotations = ref([]);

const dots = ref([]);


const devInfors = ref(null)

const outerVisible = ref(false)
const animationFrameId1  = ref(null)
const size = ref({
  width: window.innerWidth*0.75 ,
  height: window.innerHeight*0.75
})

const d3name = ref(null)

mitter.on("showflag3d", (val) => {

  d3name.value = null
  outerVisible.value = val[0]
  d3name.value = val[1]
  devInfors.value = null 
  
  getAnnotation()
  

})

  // 测点信息值
function getAnnotation(){
  let copiedModel3dinfors = JSON.parse(JSON.stringify(model3dinfors))
  devInfors.value = null 

  for (let j =1;j< copiedModel3dinfors.info.length;j++){
      
    if((copiedModel3dinfors.info[j].device_name).indexOf(d3name.value[0].device_name) != -1 ){
 
     
      devInfors.value =copiedModel3dinfors.info[j];

      break
    }
    else{
     
      devInfors.value =copiedModel3dinfors.info[0];
      
    }
  }
   for (let i =0; i<d3name.value.length;i++){
 
     const extr = d3name.value[i].name.split('_').slice(-1)[0]
   
     
     if(extr.startsWith('1')){
     
       devInfors.value.dotsinfo1.sensorval.push(d3name.value[i])
     }
     else if(extr.startsWith('2') ){
       devInfors.value.dotsinfo2.sensorval.push(d3name.value[i])
    }
    else if(extr.startsWith('3') ){
      devInfors.value.dotsinfo3.sensorval.push(d3name.value[i])
     
     }
    else if(extr.startsWith('4')){
     devInfors.value.dotsinfo4.sensorval.push(d3name.value[i])
  
  }
   if(d3name.value[i].type ==2 && d3name.value[i].stuts != 4){
         devInfors.value.current = d3name.value[i].intensity

   }
    
   }
 }
var t =1
// 定义需要显示绿点的部件名字列表
//const visibleDotsList = ['Loft002','Rectangle153','Cylinder659','Cylinder816']; // 替换为你的部件名字

// const visibleDotsList = []; // 替换为你的部件名字
// 定义 showAnnotation 和 hideAnnotation 函数
function showAnnotation(annotation) {
  annotation.visible = true;
  console.log('鼠标悬停在部件上，注释名字:', annotation.name); // 在控制台打印注释的名字
}

function hideAnnotation(annotation) {
  annotation.visible = false;
}

// 创建场景
const scene = new THREE.Scene();
// 创建相机
const camera= new THREE.PerspectiveCamera(45, window.innerWidth / window.innerHeight, 0.1, 1000);
// 创建渲染器
const renderer = new THREE.WebGLRenderer();


//打开手动
const handleOpened = () => {
  //const visibleDotsList = ['Loft002','Rectangle153','Cylinder659','Cylinder816']
  const visibleDotsList = Object.values(devInfors.value.visibleDotsListinfor); // 替换为你的部件名字
  renderer.setSize(size.value.width - 20, size.value.height - 20);
  modelContainer.value.appendChild(renderer.domElement);
  renderer.setClearColor(0x042A49, 1);
  // 添加灯光
  const ambientLight = new THREE.AmbientLight(0xffffff, 2); // 环境光，增加强度
  scene.add(ambientLight);
  const directionalLight = new THREE.DirectionalLight(0xffffff, 2); // 方向光，增加强度
  directionalLight.position.set(0, 1, 0);
  scene.add(directionalLight);
  // 创建OrbitControls
  const controls = new OrbitControls(camera, renderer.domElement);
  controls.enableDamping = true; // 启用阻尼效果
  controls.dampingFactor = 0.1; // 阻尼系数
  
  
  const loader = new GLTFLoader();
  if (devInfors.value){

      loader.load(
      devInfors.value.devPath,  // 模型文件路径 
      (gltf) => {
        const model = gltf.scene;
        scene.add(model);
        // 应用初始旋转（水平旋转90度）
        model.rotation.y = THREE.MathUtils.degToRad(devInfors.value.degToRadY);
        model.rotation.x = THREE.MathUtils.degToRad(devInfors.value.degToRadX);

        // 计算模型的边界框，以便知道模型的尺寸和位置
        const box = new THREE.Box3().setFromObject(model);
        const size = box.getSize(new THREE.Vector3());
        const center = box.getCenter(new THREE.Vector3());

        // 将模型移动到原点
        model.position.copy(center.negate());

        // 根据模型的尺寸调整相机位置
        const maxSize = Math.max(size.x, size.y, size.z);
        camera.position.set(0, 0, maxSize * 1.5);
        camera.lookAt(0, 0, 0); // 相机朝向原点

        // 更新控制器的目标点
        controls.target.set(0, 0, 0);

        // 调整模型材质
        model.traverse((child) => {
          if (child.isMesh) {
            child.name = child.name || 'Unnamed_Mesh'; // 确保名称存在
            // 检查部件名字是否在 visibleDotsList 中
            if(t==1){
           
                if (visibleDotsList.includes(child.name)) {
                 
                    // 创建注释
                    const annotation = {
                      id:visibleDotsList.indexOf(child.name),
                      name: child.name,
                      position: new THREE.Vector2(0, 0), // 初始位置
                      visible: false, //是否启用注释
                      mesh: child // 存储对网格的引用
                    };
                    annotations.value.push(annotation);
                    console.log("信息牌",annotations.value)
                    
                    // 创建绿色点
                    const dot = {
                      position: new THREE.Vector2(0, 0), // 初始位置
                      annotation: annotation // 关联的注释
                    };
                    dots.value.push(dot);
            }    
            }
            if(t==2){
            // 创建注释
            // const annotation = {
            //     name: child.name,
            //     position: new THREE.Vector2(0, 0), // 初始位置
            
            //     visible: false, //是否启用注释
            //     mesh: child // 存储对网格的引用
            //   };
            //   annotations.value.push(annotation);
        
              
              // 创建绿色点
              // const dot = {
              //   position: new THREE.Vector2(0, 0), // 初始位置
              //   annotation: annotation // 关联的注释
              // };
              dots.value.push(dot);
            }
          }
        });
        // 动画循环
        // let animationFrameId = null;
        const animate = () => {
          animationFrameId1.value  = requestAnimationFrame(animate);
          controls.update(); // 更新控制器
          renderer.render(scene, camera);
          updateAnnotations(); // 更新注释位置
        };
        animate();
        const annotationsMap ={}
        annotations.value.forEach(map =>{
          annotationsMap[map.id] = map
        })
       
        // devInfors.value.dotsinfo1.position =  annotations.value[0].position
        // devInfors.value.dotsinfo2.position  = annotations.value[1].position
        // devInfors.value.dotsinfo3.position  = annotations.value[2].position
        // devInfors.value.dotsinfo4.position  = annotations.value[3].position
        devInfors.value.dotsinfo1.position =  annotationsMap['0'].position
        devInfors.value.dotsinfo2.position  = annotationsMap['1'].position
        devInfors.value.dotsinfo3.position  = annotationsMap['2'].position
        devInfors.value.dotsinfo4.position  = annotationsMap['3'].position
    },
    // (undefined) => {
    //   // 进度事件，可以用于加载进度条等
    // },
    (error) => {
      console.error('An error happened', error);
    }
  );
  }
  else{
    console.log('无数据'); 
  }
  // 监听窗口大小变化
  window.addEventListener('resize', onWindowResize, false);

  function onWindowResize() {
    camera.aspect = window.innerWidth / window.innerHeight;
    camera.updateProjectionMatrix();
    renderer.setSize(size.value.width - 20, size.value.height - 20);
    controls.update(); // 更新控制器
  }


  // 更新注释位置
  function updateAnnotations() {
    const vector = new THREE.Vector3();
    const canvas = renderer.domElement;
    annotations.value.forEach(annotation => {
      // 获取网格的世界位置
      vector.setFromMatrixPosition(annotation.mesh.matrixWorld);
      // 将世界坐标转换为屏幕坐标
      vector.project(camera);
   
      // 计算屏幕坐标
      // const x = (vector.x * 0.5 + 0.5) * canvas.width;
      // const y = -(vector.y * 0.5 - 0.5) * canvas.height;
     
      // const x = parseInt((vector.x * 0.5 + 0.5) * size.value.width);
      // const y = -parseInt((vector.y * 0.5 - 0.5) * size.value.height);
      const x = parseInt((vector.x * 0.5 + 0.5) * canvas.width);
      const y = -parseInt((vector.y * 0.5 - 0.5) * canvas.height);
    
      // console.log("windowsinnner80",y,size.value.height,canvas.height)

      // 更新注释的位置
      annotation.position.set(x, y);
    });

    dots.value.forEach(dot => {
      // 获取网格的世界位置
      vector.setFromMatrixPosition(dot.annotation.mesh.matrixWorld);
      // 将世界坐标转换为屏幕坐标
      vector.project(camera);

      // 计算屏幕坐标
      const x = (vector.x * 0.5 + 0.5) * canvas.width;
      const y = -(vector.y * 0.5 - 0.5) * canvas.height;

      // 更新点的位置
      dot.position.set(x, y);
    });
  }
 
}

function cleanup3DScene() {
    // 假设你已经定义了 renderer、scene 和 camera
    if (renderer) {
        // 清除渲染器的 DOM 元素
        //renderer.domElement = null;
        renderer.dispose(); // 释放渲染器资源
    }

    if (scene) {
        // 遍历场景中的所有对象并释放资源
        scene.traverse((object) => {
            if (object.isMesh) {
                if (object.geometry) {
                    object.geometry.dispose(); // 释放几何体资源
                }
                if (object.material) {
                    if (Array.isArray(object.material)) {
                        object.material.forEach(material => material.dispose()); // 释放材质资源
                    } else {
                        object.material.dispose(); // 释放材质资源
                    }
                }
            }
        });
    }

    // 释放其他资源
    if (camera) {
        camera.clear();
    }
    if (scene) {
        scene.clear();
    }
    if (renderer) {
        renderer.clear();
    }

    console.log('3D 场景已销毁');
}

const handleClosed = () => {
     console.log("关闭关闭")
    if(animationFrameId1.value ){
     cancelAnimationFrame(animationFrameId1.value); // 取消动画
     animationFrameId1.value = null
    }
    dots.value = []
    annotations.value =[]
    devInfors.value = null
    cleanup3DScene()
    outerVisible.value =false
}

</script>

<style scoped lang="scss">
.model-container {
  /* width: 100%; */
  /* height: calc(100vh); */
  position: relative;
  color: #171d47;

}

.annotation {

  position: absolute;
  width: 130px;
  background-color: rgba(	25, 25,112, 0.7);
  border-radius: 8px;
  padding: 0;
  height: 230px;
  pointer-events: none;
  overflow: auto;
  transform: translate(-50%, -100%);


  .annattion_content{
    display: flex;
    flex-direction: column;
    span{
      display: block;
    }
 
  }
  .annattion_content span{
    margin-top:8px ;
  }
}

.dot {
  position: absolute;
  width: 14px;
  height: 14px;
  // background-color: green;
  background-color: rgb(126, 6, 135);
  border-radius: 50%;
  cursor: pointer;
  transform: translate(-50%, -50%);
}

</style>